// extracted by mini-css-extract-plugin
module.exports = {"container":"AssignProducer_container__LGzDm","header":"AssignProducer_header__nmfRO","assignButton":"AssignProducer_assignButton__16fbS"};